import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 22 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M6.5 0A6.5 6.5 0 0 0 0 6.5c0 2.735 1.755 4.72 3.305 6.219l6.988 6.988a1 1 0 0 0 1.414 0l6.992-6.992C20.233 11.212 22 9.23 22 6.5A6.5 6.5 0 0 0 15.5 0C13.83 0 12.397.633 11 1.793 9.603.633 8.171 0 6.5 0" }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "heart-filled"}) } }